var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 88,
    viewBox: "0 0 99 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242_710)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2242_710",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 0H0V88H99V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2242_710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 44C83 25.2223 67.7777 10 49 10C30.2223 10 15 25.2223 15 44C15 62.7777 30.2223 78 49 78C67.7777 78 83 62.7777 83 44Z",
    fill: "#F96619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1201 28.9688C63.7869 29.0191 70.7968 35.9251 70.7969 44.4376C70.7969 52.1462 65.0482 58.5362 57.5264 59.712C57.5269 59.6759 57.5293 59.6398 57.5293 59.6036C57.5293 55.4177 53.9683 51.9993 49.4854 51.7774V51.7647H41.1309C41.1302 51.7634 41.1296 51.7621 41.1289 51.7608H38.1885V51.7432C32.0662 51.4204 27.2032 46.4497 27.2031 40.3643C27.2032 34.279 32.0662 29.3083 38.1885 28.9854V28.9678L55.1201 28.9688ZM49 32.5001C48.3848 32.5002 47.886 32.9895 47.8857 33.5928V47.2364C47.8858 47.8399 48.3847 48.329 49 48.3292C49.6153 48.3291 50.1142 47.8399 50.1143 47.2364V33.5928C50.114 32.9894 49.6152 32.5001 49 32.5001ZM38.3828 34.6544C37.7676 34.6544 37.2689 35.1438 37.2686 35.7471V45.0821C37.2686 45.6857 37.7675 46.1748 38.3828 46.1749C38.9981 46.1747 39.497 45.6856 39.4971 45.0821V35.7471C39.4968 35.1438 38.998 34.6545 38.3828 34.6544ZM54.3086 34.6544C53.6935 34.6545 53.1946 35.1438 53.1943 35.7471V45.0821C53.1944 45.6856 53.6933 46.1747 54.3086 46.1749C54.9239 46.1748 55.4228 45.6856 55.4229 45.0821V35.7471C55.4225 35.1438 54.9238 34.6544 54.3086 34.6544ZM59.6172 36.2901C59.002 36.2903 58.503 36.7794 58.5029 37.3829V43.4473C58.5032 44.0506 59.0021 44.5399 59.6172 44.5401C60.2324 44.5401 60.7321 44.0507 60.7324 43.4473V37.3829C60.7323 36.7793 60.2326 36.2901 59.6172 36.2901ZM43.6914 36.7159C43.076 36.7159 42.5771 37.206 42.5771 37.8096V43.0206C42.5772 43.6242 43.076 44.1133 43.6914 44.1133C44.3068 44.1132 44.8057 43.6241 44.8057 43.0206V37.8096C44.8057 37.206 44.3068 36.716 43.6914 36.7159Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242_710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 88,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2aaf81970f006fbadf31e899896ee69c.svg";
export { ForwardRef as ReactComponent };